import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';

import Copyright from 'components/Copyright';
import FooterLink from 'components/FooterLink';

import useStyles from './Footer.style';

const Footer: React.FC = () => {
  const {
    footerLinksContainer,
    divider,
    copyrightContainer,
    footerLinkListItem,
  } = useStyles();

  return (
    <Grid
      container
      justifyContent="center"
      component="footer"
      alignItems="center"
    >
      <Grid item className={copyrightContainer}>
        <Copyright />
      </Grid>
      <Grid item>
        <List disablePadding className={footerLinksContainer}>
          <ListItem
            component={FooterLink}
            disableGutters
            to={{ pathname: 'https://bittitan.com' }}
            target="_blank"
            variant="caption"
            className={footerLinkListItem}
          >
            <ListItemText primary="Contact" disableTypography />
          </ListItem>
          <Divider
            component="li"
            orientation="vertical"
            flexItem
            className={divider}
          />
          <ListItem
            component={FooterLink}
            disableGutters
            to="/signup"
            variant="caption"
            className={footerLinkListItem}
          >
            <ListItemText primary="Legal" disableTypography />
          </ListItem>
          <Divider
            component="li"
            orientation="vertical"
            flexItem
            className={divider}
          />
          <ListItem
            component={FooterLink}
            disableGutters
            to={{ pathname: 'https://bittitan.com' }}
            target="_blank"
            variant="caption"
            className={footerLinkListItem}
          >
            <ListItemText primary="BitTitan System Status" disableTypography />
          </ListItem>
        </List>
      </Grid>
    </Grid>
  );
};

export default Footer;
